import { LoadableLazy } from '@confluence/loadable';

export const InvisibleLoadingContainer = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReadingAidsInvisibleLoadingContainer" */ '../src/InvisibleLoadingContainer.tsx'
			)
		).InvisibleLoadingContainer,
});
